import React from "react";
import { Card } from "@src/lib/ui/Card";
import { Button } from "@src/lib/ui/Button";
import Text from "@src/lib/ui/Text";
import { Tooltip, TooltipContent, TooltipTrigger } from "@src/lib/ui/Tooltip";
import XIcon from "@src/lib/icons/18px/x";
import AskOpusOrbIcon from "@src/features/assistantChat/AskOpusOrbIcon";
import { BotOrb } from "@src/features/agents/AgentAvatar";
import {
  ASK_OPUS_AGENT_ID,
  useAgentPanel,
} from "@src/features/opus-agent/agentPanel";
import {
  MANAGER_AGENTS,
  useManagerAgentsStore,
} from "@src/features/opus-agent/managerAgents";

// Introduces managers to their agents on Home, as mobile's AskOpusHomeCard;
// closed for good with its X. The agents it names are the staff prototype's
// (see managerAgents.ts), so it shows with them.
const IntroducingAgentsHomeCard: React.FC = () => {
  const { gates, userId, openAgent } = useAgentPanel();
  const dismissed = useManagerAgentsStore(
    (state) => !!userId && state.userId === userId && state.introDismissed,
  );
  if (!gates.managerAgents || !userId || dismissed) return null;

  return (
    <Card
      className="flex items-center gap-4 p-4"
      data-testid="introducing-agents-home-card"
    >
      <div className="flex shrink-0 items-center -space-x-2" aria-hidden>
        <AskOpusOrbIcon size={36} still />
        {MANAGER_AGENTS.map((agent) => (
          <BotOrb key={agent.key} color={agent.color} size={28} still />
        ))}
      </div>
      <div className="flex min-w-0 flex-1 flex-col gap-0.5">
        <Text variant="compact-title" className="text-text-primary">
          Introducing agents
        </Text>
        <Text
          variant="compact-description"
          className="text-text-secondary"
          multiline
        >
          Location health, Daily summary and New hire coach work alongside Ask
          Opus. Ask them anything.
        </Text>
      </div>
      <Button
        onClick={() => openAgent(ASK_OPUS_AGENT_ID)}
        data-testid="introducing-agents-home-card-meet"
      >
        Meet your agents
      </Button>
      <Tooltip delayDuration={0}>
        <TooltipTrigger asChild>
          <Button
            variant="ghost"
            size="icon-sm"
            className="text-icon-secondary"
            aria-label="Close"
            onClick={() =>
              useManagerAgentsStore.getState().dismissIntro(userId)
            }
            data-testid="introducing-agents-home-card-close"
          >
            <XIcon />
          </Button>
        </TooltipTrigger>
        <TooltipContent side="bottom">Close</TooltipContent>
      </Tooltip>
    </Card>
  );
};

export default IntroducingAgentsHomeCard;
